module.exports = __webpack_public_path__ + "static/media/arsha.19d94bc0.png";